import { View, YStack, Spinner, styled, useTheme } from '@ninjacart/nc-nk-ui';
import { SolitoImage } from 'solito/image';
import { Image, Platform, Pressable } from 'react-native';
import { IThumbnailProps } from '../types/IFeedVideoProps';

export const Thumbnail = ({
  thumbnailUrl,
  onPress,
  videoHeight,
  priority = false,
  loading = 'lazy',
}: IThumbnailProps) => {
  const theme = useTheme();

  return (
    <Pressable onPress={onPress}>
      <ImageWrapper height={videoHeight}>
        {Platform.OS === 'web' ? (
          <SolitoImage
            src={thumbnailUrl as any}
            alt="thumbnail"
            unoptimized
            {...(!priority && { loading })}
            sizes="(max-width: 600px) 100vw, 600px"
            fill
            style={{
              objectFit: 'cover',
              borderRadius: 0,
            }}
          />
        ) : (
          <Image
            source={{ uri: thumbnailUrl }}
            style={{
              width: '100%',
              height: videoHeight,
              borderRadius: 0,
              resizeMode: 'cover',
              backgroundColor: theme?.background?.val || '#000',
            }}
          />
        )}
      </ImageWrapper>
    </Pressable>
  );
};

const ImageWrapper = styled(YStack, {
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
});